export const getGlobalConfigValue = (name: string) => {
  const globalConfigValue =
    window[name as "APP_BASE_API_URL" | "APP_CLIENT_ID" | "APP_CLIENT_SECRET"];
  return globalConfigValue && globalConfigValue.startsWith("#")
    ? undefined
    : globalConfigValue;
};
